export default __webpack_public_path__ + "i18n/translations/translation-ar.7b501d82.json";